import { render } from "./SwapsHistory.vue?vue&type=template&id=47b734fc&scoped=true"
import script from "./SwapsHistory.vue?vue&type=script&lang=js"
export * from "./SwapsHistory.vue?vue&type=script&lang=js"

import "./SwapsHistory.vue?vue&type=style&index=0&id=47b734fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b734fc"]])

export default __exports__